import React, {useState, useEffect} from 'react';
import CustomCheckbox from '../CustomCheckbox/CustomCheckbox';
import SortArrow from '../SortArrow/SortArrow';
import './UniversalTable.css';
import TableRow from '../TableRow/TableRow';

const UniversalTable = ({
  data: initialData,
  columns,
  onSelectItem,
  selectedItems,
  handleContextMenu,
  expandedRow,
  onRowClick,
  deleteError,
  menuTarget,
  showCheckboxes = true,
}) => {
  const [sortedData, setSortedData] = useState([]);
  const [sortConfig, setSortConfig] = useState({key: null, direction: null});
  useEffect(() => {
    if (typeof initialData === 'string') {
      try {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        initialData = JSON.parse(initialData);
      } catch (error) {
        console.error('Ошибка парсинга initialData:', error);
        setSortedData([]);
        return;
      }
    }

    if (Array.isArray(initialData)) {
      setSortedData([...initialData]);
    } else {
      console.error('initialData не является массивом:', initialData);
      setSortedData([]);
    }
  }, [initialData]);

  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    } else if (sortConfig.key === key && sortConfig.direction === 'desc') {
      direction = null;
    }

    setSortConfig({key, direction});

    if (direction === null) {
      setSortedData(Array.isArray(initialData) ? [...initialData] : []);
      return;
    }

    const sortedList = [...(initialData || [])].sort((a, b) => {
      if (a[key] < b[key]) return direction === 'asc' ? -1 : 1;
      if (a[key] > b[key]) return direction === 'asc' ? 1 : -1;
      return 0;
    });

    setSortedData(sortedList);
  };

  const handleSelectAll = () => {
    const allSelected = sortedData.every((item) =>
      selectedItems.includes(item.id)
    );

    if (allSelected) {
      sortedData.forEach((item) => onSelectItem(item.id));
    } else {
      sortedData.forEach((item) => {
        if (!selectedItems.includes(item.id)) {
          onSelectItem(item.id);
        }
      });
    }
  };

  return (
    <table className='universal-table__content'>
      <thead className='universal-table__header'>
        <tr>
          {showCheckboxes && (
            <th className='universal-table__cell universal-table__cell_header'>
              <CustomCheckbox
                onChange={handleSelectAll}
                checked={
                  sortedData.length > 0 &&
                  sortedData.every((item) => selectedItems.includes(item.id))
                }
              />
            </th>
          )}
          {columns.map((column) => (
            <th
              key={column.key}
              onClick={() => handleSort(column.key)}
              className='universal-table__cell universal-table__cell_header'
            >
              <div className='universal-table__cell-content'>
                <SortArrow
                  direction={
                    sortConfig.key === column.key ? sortConfig.direction : null
                  }
                />
                <span>{column.title}</span>
              </div>
            </th>
          ))}
        </tr>
      </thead>
      <tbody className='universal-table__body'>
        {sortedData.length > 0 ? (
          sortedData.map((item, index) => (
            <React.Fragment key={item.id || `empty-${index}`}>
              <TableRow
                rowData={item}
                columns={columns}
                onSelect={onSelectItem}
                isSelected={selectedItems.includes(item.id)}
                handleContextMenu={handleContextMenu}
                isExpanded={expandedRow === item.id}
                onRowClick={() => onRowClick(item.id)}
                deleteError={menuTarget?.id === item.id ? deleteError : null}
                showCheckboxes={showCheckboxes}
              />

              {expandedRow === item.id && item.children && (
                <tr>
                  <td colSpan={columns.length + 1}>
                    <div className='nested-table'>{item.children}</div>
                  </td>
                </tr>
              )}
            </React.Fragment>
          ))
        ) : (
          <tr>
            <td colSpan={columns.length + 1} className='empty-table'>
              Нет данных
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

export default UniversalTable;
